var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _NotificationsStore_navigate;
var NotificationsStore_1;
import { toast } from '@servicetitan/anvil2';
import { injectable, inject, optional } from '@servicetitan/react-ioc';
import { action, runInAction, comparer, makeObservable } from 'mobx';
import { NotificationsApi, NotificationProcessStatus as ServerNotificationStatus, } from '../api/notifications.api';
import { Status, isLinkAction, isNewer } from '../common';
import { NOTIFICATIONS_CHANNEL_TOKEN } from '../notifications-channel';
import { dateFromString } from '../utils/date-from-string';
const EVENT_NAME = 'NotificationEvent';
const CLIENT_NOTIFICATION_TYPE = 'ClientNotification';
const CLIENT_NOTIFICATION_VERSION = 1;
const DAY_INTERVAL = 24 * 60 * 60 * 1000;
let NotificationsStore = NotificationsStore_1 = class NotificationsStore {
    constructor(notificationsApi, notificationsChannel) {
        Object.defineProperty(this, "notificationsApi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notificationsApi
        });
        Object.defineProperty(this, "notificationsChannel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notificationsChannel
        });
        Object.defineProperty(this, "index", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: -1
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "intervalId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "closedNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        _NotificationsStore_navigate.set(this, void 0);
        Object.defineProperty(this, "initialize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (userId) => {
                this.userId = userId;
                if (this.publisher) {
                    this.publisher.bind(EVENT_NAME, this.onPublisherEvent);
                }
                this.intervalId = window.setInterval(() => this.cleanupClosedNotifications(), DAY_INTERVAL);
                if (!this.notificationsApi) {
                    return;
                }
                const notifications = (await this.notificationsApi.getNotifications(false)).data;
                runInAction(() => {
                    for (const notification of notifications) {
                        this.updateIfNewer(notification);
                    }
                });
            }
        });
        Object.defineProperty(this, "dispose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.publisher) {
                    this.publisher.global_emitter.unbind(EVENT_NAME, this.onPublisherEvent);
                }
                window.clearInterval(this.intervalId);
            }
        });
        Object.defineProperty(this, "add", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (options, preventDuplicates) => {
                const notification = {
                    id: this.index,
                    userId: this.userId,
                    type: CLIENT_NOTIFICATION_TYPE,
                    status: ServerNotificationStatus.Info,
                    isRead: false,
                    createdOn: new Date(),
                    modifiedOn: new Date(),
                    version: CLIENT_NOTIFICATION_VERSION,
                    payload: { ...options },
                };
                if (preventDuplicates) {
                    if ([...this.notifications.values()].some(({ payload }) => comparer.structural(payload, notification.payload))) {
                        return;
                    }
                    this.notifications.set(notification.id, notification);
                }
                const method = this.getToastMethod(notification);
                notification.toastId = toast[method](this.getToastProps(notification));
                this.index -= 1;
            }
        });
        Object.defineProperty(this, "read", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notification) => {
                if (notification.id > 0) {
                    if (notification.status === ServerNotificationStatus.InProgress) {
                        this.closedNotifications.set(notification.id, {
                            status: notification.status,
                            timestamp: Date.now(),
                        });
                    }
                    if (this.notificationsApi) {
                        this.notificationsApi.changeIsReadProperty(notification.id, true, notification.version);
                    }
                }
                this.notifications.delete(notification.id);
            }
        });
        Object.defineProperty(this, "onPublisherEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notification) => {
                if (notification.userId !== this.userId) {
                    return;
                }
                this.updateIfNewer({
                    ...notification,
                    createdOn: dateFromString(notification.createdOn),
                    modifiedOn: dateFromString(notification.modifiedOn),
                });
            }
        });
        makeObservable(this);
    }
    static intercept(type, fn) {
        if (fn) {
            NotificationsStore_1.interceptors.set(type, fn);
        }
        else {
            NotificationsStore_1.interceptors.delete(type);
        }
    }
    get publisher() {
        var _a;
        return (_a = this.notificationsChannel) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    get navigate() {
        return __classPrivateFieldGet(this, _NotificationsStore_navigate, "f");
    }
    set navigate(fn) {
        __classPrivateFieldSet(this, _NotificationsStore_navigate, fn, "f");
    }
    cleanupClosedNotifications() {
        for (const [id, { timestamp }] of Array.from(this.closedNotifications)) {
            if (Date.now() - timestamp > DAY_INTERVAL) {
                this.closedNotifications.delete(id);
            }
        }
    }
    updateIfNewer(notification) {
        const closed = this.closedNotifications.get(notification.id);
        if (closed) {
            if (closed.status === notification.status) {
                return;
            }
            this.closedNotifications.delete(notification.id);
        }
        const clientNotification = this.toClientNotification(notification);
        if (!clientNotification) {
            return;
        }
        const existing = this.notifications.get(notification.id);
        if (existing) {
            if (!isNewer(existing, notification)) {
                return;
            }
            if (notification.status === existing.status ||
                notification.status === ServerNotificationStatus.InProgress) {
                toast.update(existing.toastId, this.getToastProps(clientNotification));
                clientNotification.toastId = existing.toastId;
                this.notifications.set(notification.id, clientNotification);
                return;
            }
            toast.dismiss(existing.toastId);
        }
        const method = this.getToastMethod(clientNotification);
        clientNotification.toastId = toast[method](this.getToastProps(clientNotification));
        this.notifications.set(notification.id, clientNotification);
    }
    getToastMethod({ payload: { status } }) {
        switch (status) {
            case Status.Success:
                return 'success';
            case Status.Error:
                return 'danger';
            case Status.Warning:
                return 'warning';
            default:
                return 'info';
        }
    }
    getToastProps(notification) {
        const { action, duration = 8000, message = '', progress, title } = notification.payload;
        return {
            actions: this.getToastActions(notification),
            duration: action ? false : duration,
            message,
            onClose: () => this.handleClose(notification),
            progress,
            title,
        };
    }
    getToastActions(notification) {
        const { action } = notification.payload;
        if (!action) {
            return;
        }
        return {
            primary: {
                label: action.label,
                onClick: () => this.handleClick(notification),
            },
        };
    }
    handleClick({ payload: { action }, toastId }) {
        var _a;
        if (action) {
            if (isLinkAction(action)) {
                if (action.external) {
                    window.open(action.link);
                }
                else {
                    (_a = this.navigate) === null || _a === void 0 ? void 0 : _a.call(this, action.link);
                }
            }
            else {
                action.onClick();
            }
        }
        toast.dismiss(toastId);
    }
    handleClose(notification) {
        this.read(notification);
    }
    toClientNotification(serverNotification) {
        var _a;
        const result = {
            ...serverNotification,
            payload: {
                ...JSON.parse((_a = serverNotification.payload) !== null && _a !== void 0 ? _a : '{}'),
                status: this.toClientStatus(serverNotification.status),
            },
        };
        const interceptor = NotificationsStore_1.interceptors.get(serverNotification.type);
        if (!interceptor) {
            return result;
        }
        const dismiss = () => {
            var _a;
            const toastId = (_a = this.notifications.get(result.id)) === null || _a === void 0 ? void 0 : _a.toastId;
            if (toastId) {
                toast.dismiss(toastId);
            }
        };
        return interceptor(result, dismiss);
    }
    toClientStatus(status) {
        switch (status) {
            case ServerNotificationStatus.Success:
                return Status.Success;
            case ServerNotificationStatus.Failure:
                return Status.Error;
            default:
                return Status.Info;
        }
    }
};
_NotificationsStore_navigate = new WeakMap();
Object.defineProperty(NotificationsStore, "interceptors", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: new Map()
});
__decorate([
    action,
    __metadata("design:type", Object)
], NotificationsStore.prototype, "add", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], NotificationsStore.prototype, "read", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], NotificationsStore.prototype, "onPublisherEvent", void 0);
NotificationsStore = NotificationsStore_1 = __decorate([
    injectable(),
    __param(0, inject(NotificationsApi)),
    __param(0, optional()),
    __param(1, inject(NOTIFICATIONS_CHANNEL_TOKEN)),
    __param(1, optional()),
    __metadata("design:paramtypes", [NotificationsApi, Function])
], NotificationsStore);
export { NotificationsStore };
//# sourceMappingURL=notifications.store.js.map